import {clsx} from 'external/clsx'
import {FC, PropsWithChildren, ChangeEventHandler, CSSProperties} from 'external/react'

type SwitchProps = {
	className?: string,
	checked?: boolean,
	defaultChecked?: boolean
	style?: CSSProperties
	onChange?: ChangeEventHandler<HTMLInputElement>	
}

const Switch:FC<PropsWithChildren<SwitchProps>>  = props => {
	const { className, onChange, defaultChecked, children, checked } = props
	return (
		<>
			<label className={clsx('switch', className)}>
				<input type='checkbox' onChange={onChange} defaultChecked={defaultChecked} checked={checked} />
				<span className='slider round'></span>
			</label>
			{children}
		</>
	)
}

export {Switch as default}